import { httpApi } from "api/http.api";
import {
  ICHOrderDetailsRequest,
  ICHOrderListRequest,
  ICHTrunkDetailsRequest,
} from "interfaces/APIInterface/IPerlickAPIInterface/ICHOrder";

export const PerlickCHOrderList = (chOrderRequestPayload: ICHOrderListRequest) => {
  return httpApi
    .post("/perlickorder/getchorderlist", chOrderRequestPayload)
    .then((response) => response)
    .catch((error) => {
      throw error;
    });
};

export const PerlickCHOrderDetailsList = (chOrderDetailRequestPayload: ICHOrderDetailsRequest) => {
  return httpApi
    .post("/perlickorder/getchorderdetail", chOrderDetailRequestPayload)
    .then((response) => response)
    .catch((error) => {
      throw error;
    });
};

export const PerlickCHTrunkDetailsList = (chTrunkDetailRequestPayload: ICHTrunkDetailsRequest) => {
  return httpApi
    .post("/perlickorder/getchtrunkdetail", chTrunkDetailRequestPayload)
    .then((response) => response)
    .catch((error) => {
      throw error;
    });
};
